import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber1Circle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNumber1Circle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.4043 7.77246L9.25391 9.2373V11.0889L11.293 9.71191H11.4043V16.2275H13.4004V7.77246H11.4043Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber1Circle;
